export default __webpack_public_path__ + "static/media/noemie_montmartre.c4caddc2.jpg";